import {
  CommentUnfurlModel,
  CommentUnfurlTypesEnum,
  TagCommentUnfurlModel,
} from '../../../../../src/models/api/commentUnfurlModel';

export type OutOfLineCommentUnfurlModel = Exclude<CommentUnfurlModel, TagCommentUnfurlModel>;

/**
 * Comment unfurls can be of two types: inline or out-of-line.
 * Inline means it will only be displayed in the comment text itself.
 * Out-of-line means it will be displayed in the comment text (light mofification, like bold)
 * and in the comment unfurl section below the comment text.
 * For now, only tags are fully inline.
 */
export function isCommentUnfurlOutOfLine(unfurl: CommentUnfurlModel): unfurl is OutOfLineCommentUnfurlModel {
  return unfurl.type !== CommentUnfurlTypesEnum.TAG;
}
